import { defineStore } from 'pinia';
import { ref, computed } from 'vue'

export const usePortfolioStore = defineStore('portfolio', {
    state: () => ({
        // Module Elements
        campaigns: [],
        folderUpload: '',
        isFetching: true,
        pageCampaign: 1,
        resultMessage: {
            type: '',
            message: '',
        },
        siteUrl: '',
        totalCampaignsGeneral: 0,
    }),
    actions: {
        // Filter Actions
        cleanCampaigns() {
            this.campaigns = [];
            this.totalCampaignsGeneral = 0;
        },
        // Module Actions
        addCampaignsByPage(value) {
            const { campaigns, page } = value;
            this.campaigns[page] = campaigns;
        },
        setCurrentRoute(value) {
            this.currentRoute = value;
        },
        setFolderUpload(value) {
            this.folderUpload = value;
        },
        setIsFetching(value) {
            this.isFetching = value;
        },
        setPageCampaign(value) {
            this.pageCampaign = value;
        },
        setResultMessage(value) {
            this.resultMessage = value;
        },
        setSiteUrl(value) {
            this.siteUrl = value;
        },
        setTotalCampaignsGeneral(value) {
            if (typeof value === 'number' || value === null || value === undefined) {
                this.totalCampaignsGeneral = value;
            } else {
                console.warn('Invalid value for totalCampaignsGeneral:', value);
                this.totalCampaignsGeneral = Number(value) || 0;
            }
        },
    },
    getters: {
        // Module Getters
        getCampaigns: (state) => state.campaigns,
        getCampaignsByPage: (state) => (page) => state.campaigns[page],
        getFolderUpload: (state) => state.folderUpload,
        getIsFetching: (state) => state.isFetching,
        getPageCampaign: (state) => state.pageCampaign,
        getResultMessage: (state) => state.resultMessage,
        getSiteUrl: (state) => state.siteUrl,
        getTotalCampaignsGeneral: (state) => state.totalCampaignsGeneral,
    },
});
